/** 店群 COS：南京旧桶 → 广州新桶（库内旧域名出站统一替换，不改库） */
export const LEGACY_DELI_COS_HOST = "deli5566-1302306535.cos.ap-nanjing.myqcloud.com";
export const CURRENT_DELI_COS_HOST = "deli5566-1301191564.cos.ap-guangzhou.myqcloud.com";
export const CURRENT_DELI_COS_URL = "https://" + CURRENT_DELI_COS_HOST;

export function rewriteLegacyDeliCosUrl(input) {
    if (input == null) {
        return input;
    }
    if (typeof input === "string") {
        if (!input.includes(LEGACY_DELI_COS_HOST)) {
            return input;
        }
        return input.split(LEGACY_DELI_COS_HOST).join(CURRENT_DELI_COS_HOST);
    }
    if (Array.isArray(input)) {
        return input.map(rewriteLegacyDeliCosUrl);
    }
    if (typeof input === "object") {
        const out = {};
        for (const k of Object.keys(input)) {
            out[k] = rewriteLegacyDeliCosUrl(input[k]);
        }
        return out;
    }
    return input;
}
